import { Module } from "@/constants";
import { useDefaultStoreProjectAssigneeId } from "@/modules/defaultStoreProjectAssignees/hooks/useDefaultStoreProjectAssigneeId";
import { DefaultStoreProjectAssigneesService } from "@/services/defaultStoreProjectAssignees";
import { useQuery } from "@tanstack/react-query";

export const useDefaultStoreProjectAssignee = (enabled = true) => {
  const assigneeId = useDefaultStoreProjectAssigneeId();
  return useQuery({
    queryKey: [Module.DefaultStoreProjectAssignees, assigneeId],
    queryFn: () => DefaultStoreProjectAssigneesService.getById(assigneeId),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
